import { IDetalleLinea } from './detalle-linea.model';

export interface IPeriodicidad {
  id?: number;
  nombre?: string | null;
  cantidadMeses?: number | null;
  detallesLineas?: IDetalleLinea[] | null;
}

export class Periodicidad implements IPeriodicidad {
  constructor(
    public id?: number,
    public nombre?: string | null,
    public cantidadMeses?: number | null,
    public detallesLineas?: IDetalleLinea[] | null
  ) {}
}
